<template>
    <section v-if="isAllowed" class="main-container" :class="containerClass">
        <div
            v-if="activeViewStage.tag != 'finished' && !selectedRate"
            class="close"
            @click="finishAndClose"
        >
            <em class="fal fa-times fa-lg"/>
        </div>

        <div v-if="activeViewStage.tag == 'finished'" class="smile">
            <em class="fal fa-laugh-beam fa-5x"/>
        </div>

        <div class="message">
            {{ properMessage }}
        </div>

        <div v-show="activeViewStage.tag == 'select-rate'">
            <ui-select-rate v-model="selectedRate" :nps-config="npsConfig" />

            <div class="buttons">
                <button :disabled="!selectedRate" class="send-button mt-10" @click="selectRate">
                    {{ selectRateButton }}
                </button>
            </div>
        </div>

        <div v-show="activeViewStage.tag == 'send-message-question'">
            <div class="radio">
                <ui-radio name="yes/no" label="Sim" value="yes" checked @input="radioHandler" />
                <ui-radio name="yes/no" label="Não" value="no" @input="radioHandler" />
            </div>

            <div class="buttons">
                <button class="back-button" @click="setViewStage('select-rate')">voltar</button>
                <button
                    :disabled="!sendMessageQuestionValue"
                    :class="buttonClass"
                    class="next-button"
                    @click="sendMessageQuestion"
                >
                    {{ sendMessageQuestionButton }}
                </button>
            </div>
        </div>

        <div v-show="activeViewStage.tag == 'send-message'">
            <textarea
                v-model="sendMessage"
                placeholder="Digite sua mensagem..."
                cols="30"
                rows="4"
                class="text-area"
            />

            <div class="warning">{{ commentMinSizeMessage }}</div>

            <div class="buttons">
                <button class="back-button" @click="setViewStage('send-message-question')">
                    voltar
                </button>
                <button
                    :disabled="sendMessage.length < commentMinSize"
                    class="send-button"
                    @click="sendNPSRate"
                >
                    Enviar
                </button>
            </div>
        </div>

        <div v-show="activeViewStage.tag == 'finished'">
            <button class="close-button" @click="close">Fechar</button>
        </div>

        <ui-overlay-load v-if="loader.load" />
    </section>
</template>

<script>
	import uiSelectRate from './components/select-rate/index.vue'

	import { helpersMixin } from '@/mixins'
	import rulesMixin from './mixins/rules.js'
	import servicesMixin from './services/methods.js'

	import { uiOverlayLoad } from '@/components/ui'
	import { uiRadio } from '@/components/ui/form'

	const defaultViewStage = () => [
		{
			tag: 'select-rate',
			active: true,
		},
		{
			tag: 'send-message-question',
			active: false,
		},
		{
			tag: 'send-message',
			active: false,
		},
		{
			tag: 'finished',
			active: false,
		},
	]

	const defaultLoader = () => ({
		load: false,
	})

	export default {
		name: 'ui-rating-nps',

		components: {
			uiSelectRate,
			uiOverlayLoad,
			uiRadio,
		},

		mixins: [helpersMixin, rulesMixin, servicesMixin],

		data() {
			return {
				viewStage: [...defaultViewStage()],

				selectedRate: null,
				sendMessage: '',

				npsConfig: null,

				loader: { ...defaultLoader() },

				forceClose: false,

				sendMessageQuestionValue: 'yes',
			}
		},

		computed: {
			// Retorna a view ativa atual
			activeViewStage() {
				return this.viewStage.find((view) => view.active)
			},

			// Altera a classe do CSS se a view finished for alcançada
			containerClass() {
				return { finished: this.activeViewStage.tag == 'finished' }
			},

			// Retorna o texto correto para o botão
			selectRateButton() {
				if (this.commentsActive) return 'Avançar'

				return 'Enviar'
			},

			// Retorna o texto correto para o botão com base na escolha do usuário
			sendMessageQuestionButton() {
				if (this.sendMessageQuestionValue == 'yes') return 'Avançar'

				return 'Enviar'
			},

			// Retorna o texto correto para o mínimo dos caracteres
			commentMinSizeMessage() {
				return 'Mínimo de ' + this.commentMinSize + ' caracteres'
			},

			// Retorna a classe correta para o botão
			buttonClass() {
				return { send: this.sendMessageQuestionValue == 'no' }
			},
		},

		created() {
			// Sincroniza os dados salvos no local storage com os dados locais do componente
			this.syncNPSConfig(this.userIdentity)
		},

		async mounted() {
			// Realiza a requisição para receber a configuração NPS
			await this.getNPSConfig(this.userIdentity, this.userGroup)

			// Verifica se app foi fechado. Se tiver sido fechado, faz uma verificação para ver se
			// o tempo definido em nps_force_reply_time foi atingido e, então, faz o reset da variável nps_closed
			this.verifyClosed()

			// Verifica se é hora de fazer um novo request para receber a configuração NPS.
			// A requisição só é feita 1 vez por dia.
			await this.verifyNextRequest()
		},

		methods: {
			// Seta uma view
			setViewStage(tag) {
				this.viewStage.forEach((element) => {
					if (element.tag == tag) {
						element.active = true
						return
					}

					element.active = false
				})
			},

			// Callback para o ui-radio
			radioHandler(value) {
				this.sendMessageQuestionValue = value
			},

			// Decide a ação correta para o botão
			async selectRate() {
				if (this.commentsActive) {
					this.setViewStage('send-message-question')
					return
				}

				await this.sendNPSRate()
			},

			// Decide a ação correta para o botão
			async sendMessageQuestion() {
				if (this.sendMessageQuestionValue == 'yes') {
					this.setViewStage('send-message')
					return
				}

				await this.sendNPSRate()
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
